import { render, staticRenderFns } from "./VoorzieningHome.vue?vue&type=template&id=7760f940&"
import script from "./VoorzieningHome.vue?vue&type=script&lang=js&"
export * from "./VoorzieningHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports